import { clsx } from 'clsx';
import type { ReactNode } from 'react';

type GoldenSealSize = 'sm' | 'md' | 'lg';

type GoldenSealProps = {
  text?: string;
  size?: GoldenSealSize;
  children?: ReactNode;
  className?: string;
};

const SIZE_CLASSES: Record<GoldenSealSize, { wrap: string; text: string; icon: string }> = {
  sm: { wrap: 'w-20 h-20', text: 'text-[8px]', icon: 'w-6 h-6' },
  md: { wrap: 'w-32 h-32', text: 'text-[10px]', icon: 'w-10 h-10' },
  lg: { wrap: 'w-48 h-48', text: 'text-xs', icon: 'w-16 h-16' },
};

export function GoldenSeal({
  text = 'Registro Verificado · Touch the Trophy ·',
  size = 'md',
  children,
  className,
}: GoldenSealProps) {
  const sizes = SIZE_CLASSES[size];
  const textId = `goldenseal-text-${size}`;
  const repeated = `${text}  ${text}`;

  return (
    <div className={clsx('relative', sizes.wrap, className)}>
      {/* Anel externo dourado */}
      <div className="absolute inset-0 rounded-full border border-gold/50" />
      <div className="absolute inset-1 rounded-full border border-gold/30" />

      {/* Texto circular */}
      <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full animate-spin-slow">
        <defs>
          <path id={textId} d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" />
        </defs>
        <text
          fill="#E8D5A8"
          className={clsx('font-mono uppercase tracking-stamp', sizes.text)}
          style={{ fontWeight: 500 }}
        >
          <textPath xlinkHref={`#${textId}`}>{repeated}</textPath>
        </text>
      </svg>

      {/* Conteúdo central (default: ornament/check dourado) */}
      <div className="absolute inset-0 flex items-center justify-center">
        {children ?? (
          <svg
            viewBox="0 0 32 32"
            className={clsx(sizes.icon, 'text-gold')}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="16" cy="16" r="11" />
            <path d="M11 16.5l3.5 3.5L22 12" />
          </svg>
        )}
      </div>
    </div>
  );
}
